import { render, staticRenderFns } from "./tabs_with_list.vue?vue&type=template&id=15d69da6"
import script from "./tabs_with_list.vue?vue&type=script&lang=js"
export * from "./tabs_with_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports